<template>
  <v-sheet class="py-8 sm:py-4 lg:py-12 xl:py-20">
    <slot />
  </v-sheet>
</template>

<script setup lang="ts">

</script>
